module.exports = __webpack_public_path__ + "img/59.c3bf89b2.jpg";